import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import WebApiRoutes from '@config/Routes/WebApiRoutes';
import WebApiGeneralRoutes from '@config/Routes/WebApiGeneralRoutes';

const baseQuery = fetchBaseQuery({
  baseUrl: WebApiRoutes.getBaseUrl(),
});

const ResellerSettingsApi = createApi({
  reducerPath: 'resellerSettingsApi',
  baseQuery,
  endpoints: (builder) => ({
    editSmtpSettings: builder.mutation({
      query: ({ accessToken, params }) => ({
        url: WebApiGeneralRoutes.apiV1Path('/edit_reseller_smtp_settings'),
        method: 'POST',
        headers: { Authorization: `Bearer ${accessToken}` },
        body: params,
      }),
    }),
    sendTestEmail: builder.mutation({
      query: ({ accessToken, params }) => ({
        url: WebApiGeneralRoutes.apiV1Path('/send_test_email'),
        method: 'POST',
        headers: { Authorization: `Bearer ${accessToken}` },
        body: params,
      }),
    }),
    privateApiSupported: builder.mutation({
      query: ({ accessToken }) => ({
        url: WebApiGeneralRoutes.apiV1Path('/private_api_supported'),
        method: 'GET',
        headers: { Authorization: `Bearer ${accessToken}` },
      }),
    }),
  }),
});

export const {
  useEditSmtpSettingsMutation,
  useSendTestEmailMutation,
  usePrivateApiSupportedMutation,
} = ResellerSettingsApi;

export default ResellerSettingsApi;
